import React, { useState } from "react";
import { Map, TileLayer, Marker } from "react-leaflet";
import L from 'leaflet';

import gfMarker from '../../images/marker.png';

import "./style.css";


const marker = new L.Icon({
    iconUrl: gfMarker,
    iconSize: [45, 45],
    iconAnchor:[22, 44],
    className: 'leaflet-div-icon'
});

const MapComponent = () => {
  const [position] = useState({
    lat: 45.528922,
    lng: 10.365601,
    zoom: 16
  });

  return (
    <div className="section map-section">
      <div className="div-map">
        <Map center={position} zoom={position.zoom} className="map">
          <TileLayer
            attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <Marker position={position} icon={ marker }>
          </Marker>
        </Map>
      </div>
    </div>
  );
};

export default MapComponent;
